<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="友情链接"
      edit-title
      id-key="LinkId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="Title">
               <el-input v-model="data.Title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="链接地址" prop="Url">
              <el-input v-model="data.Url" placeholder="请输入用户账号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="排序" prop="Sort">
              <el-input-number :min="0" v-model="data.Sort"></el-input-number>
              <span class="t-tips">值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
 
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
      LinkId: 0,
      Title: "",
      Url: "",
      Sort: 0,
      },
      isEdit: false,
      api: require("@/api/website/link/link").default,
      rules: {
        Title: [{ required: true, message: "标题不能为空" }],
        Url: [{ required: true, message: "链接地址不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
    },
    onEditOpened(data) {
    },

  },
};
</script>